/**
  https://flatuicolors.com
*/
const WHITE_WHITE_WHITE = '#ffffff';
const ANTI_FLASH_WHITE = '#f1f2f6';
const CITY_LIGHTS = '#dfe4ea';
const TWINKLE_BLUE = '#ced6e0';
const HINT_OF_ICE_PACK = '#c7ecee';
const BLURPLE = '#4834d4';
const MIDDLE_BLUE = '#17a2b8';
const PRESTIGE_BLUE = '#2f3542';
const PEACE = '#a4b0be';
const STORM_PETREL = '#8395a7';

export const COLORS = {
  select: BLURPLE,
  createGroupText: BLURPLE,
  groupingRectBG: HINT_OF_ICE_PACK,
  groupingRectDefault: CITY_LIGHTS,
  rectBg: ANTI_FLASH_WHITE,
  rectDefault: MIDDLE_BLUE,
  arrowDefault: PEACE,
  arrowGhost: `rgba(164, 176, 190, 0.6)`,
  canvas: TWINKLE_BLUE,
  appBg: PRESTIGE_BLUE,
  text: PRESTIGE_BLUE,
  textContrast: WHITE_WHITE_WHITE,
  placeholderText: PEACE,
  secondaryText: PEACE,
  tooltipText: STORM_PETREL,
  selectionArea: STORM_PETREL,
  selectionInProgress: PEACE,
  cockpitUnselectedBg: WHITE_WHITE_WHITE,
  cockpitSelectedBg: PEACE,
  dropShadow: PEACE,
  ghost: PEACE,
  feedbackBg: WHITE_WHITE_WHITE,
  feedbackSubmit: MIDDLE_BLUE,
};

const BRUSCHETTA_TOMATO = '#ff6348';
const UFO_GREEN = '#2ed573';
const ORANGE = '#ffa502';
const HELIOTROPE = '#e056fd';
const CLEAR_CHILL = '#1e90ff';
const LIGHT_SLATE_BLUE = '#7d5fff';
const YOUNG_SALMON = '#ffb8b8';
const MANDARIN_SORBET = '#ffaf40';
const BRIGHT_LILAC = '#cd84f1';
const KEPPEL = '#58B19F';
const SPIRO_DISCO_BALL = '#25CCF7';
const QUINCE_JELLY = '#ffbe76';

export const PALETTE = [
  HELIOTROPE,
  QUINCE_JELLY,
  UFO_GREEN,
  CLEAR_CHILL,
  BRUSCHETTA_TOMATO,
  LIGHT_SLATE_BLUE,
  YOUNG_SALMON,
  MANDARIN_SORBET,
  SPIRO_DISCO_BALL,
  BRIGHT_LILAC,
  KEPPEL,
  ORANGE,
];
